import { COLORS } from '../../constants/colors';

import { IStyles } from '../../interfaces/styles';

export const classes: IStyles = {
  onlineIcon: {
    color: COLORS.ONLINE_GREEN,
    fontSize: 8,
  },
  offlineIcon: {
    color: COLORS.RED,
    fontSize: 8,
    opacity: 0.5,
  },
};
